module.exports = __webpack_public_path__ + "media/gallery/photo07-74fd2b9e.webp";